<template>
    <window
      :title="`${$t(isLive ? 'Cam Live' : 'Cam Playback')} - ${device.name}`"
      :pos="[400, 400]"
      :dims="[300, 300]" 
      :minDims="[300, 300]"
      :maxDims="[900, 900]"
      @close="()=> $emit('close')"
      >
      <iframe allow="fullscreen" class="h-100 w-100 cam-stream-frame" :src="`/cam/${isLive ? 'live' : 'playback'}.html?device=${device.id}${ !isLive ? `&from=${from}&to=${to}` : ''}&fullMode=true`"></iframe>
    </window>
</template>
  
<script>
  
  import window from '../Window.vue'
  
  export default {
    name: 'CamStream',
    components: {
        window
    },
    props: {
      isLive: {
        type: Boolean,
        default: true
      },
      device:{
        type:Object
      },
      from: {
        type: String
      },
      to: {
        type: String,
      }
    }
  }
  </script>
  
  <style lang="scss">
  .cam-stream-frame {
    border: none !important;
  }
  </style>
  